import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Online ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Offline ")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  style: {"font-weight":"bolder"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Start")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Reset")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Reveal ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" You seem to be the first around here.")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Invite some mates ")
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" As observer you do not figure in the list of team mates and thus can not cast an estimate.")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("I am participating in estimation")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("I am observing")
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Estimate")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Observe")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Online ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Offline ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Delete mate. ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Reset default values ")
const _hoisted_29 = { key: 3 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("I am participating in estimation")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("I am observing")
const _hoisted_32 = {
  key: 4,
  style: {"width":"100%","text-align":"center","display":"inline-block"}
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode()
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Copy to clipboard ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Loading")
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  value: "",
  id: "clipTmp",
  hidden: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_gradient_text = _resolveComponent("n-gradient-text")!
  const _component_n_avatar = _resolveComponent("n-avatar")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_wifi_120_regular = _resolveComponent("wifi-120-regular")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_wifi_off_20_regular = _resolveComponent("wifi-off-20-regular")!
  const _component_n_h1 = _resolveComponent("n-h1")!
  const _component_n_layout_header = _resolveComponent("n-layout-header")!
  const _component_n_menu = _resolveComponent("n-menu")!
  const _component_n_layout_sider = _resolveComponent("n-layout-sider")!
  const _component_checkmark_12_filled = _resolveComponent("checkmark-12-filled")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_list_item = _resolveComponent("n-list-item")!
  const _component_play_20_regular = _resolveComponent("play-20-regular")!
  const _component_arrow_reset_20_filled = _resolveComponent("arrow-reset-20-filled")!
  const _component_n_list = _resolveComponent("n-list")!
  const _component_qr_code_20_filled = _resolveComponent("qr-code-20-filled")!
  const _component_n_grid_item = _resolveComponent("n-grid-item")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_switch = _resolveComponent("n-switch")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_delete_16_regular = _resolveComponent("delete-16-regular")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_image = _resolveComponent("n-image")!
  const _component_n_a = _resolveComponent("n-a")!
  const _component_copy_16_regular = _resolveComponent("copy-16-regular")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_n_layout = _resolveComponent("n-layout")!
  const _component_n_progress = _resolveComponent("n-progress")!
  const _component_n_layout_footer = _resolveComponent("n-layout-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_layout, null, {
      default: _withCtx(() => [
        _createVNode(_component_n_layout_header, {
          style: {"height":"48px","line-height":"48px","padding":"2px 24px 2px 24px"},
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_h1, null, {
              default: _withCtx(() => [
                _createVNode(_component_n_gradient_text, {
                  type: "primary",
                  style: {"max-width":"calc(100% - 111px)"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.title), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_tooltip, {
                  trigger: "hover",
                  placement: "bottom-end"
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(_component_n_avatar, {
                      round: "",
                      size: "medium",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('~/settings'))),
                      style: {"float":"right","margin-top":"5px","margin-left":"16px","cursor":"pointer"},
                      src: _ctx.myself.icon
                    }, null, 8, ["src"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.myself.name), 1)
                  ]),
                  _: 1
                }),
                (_ctx.wsConnected)
                  ? (_openBlock(), _createBlock(_component_n_tooltip, {
                      key: 0,
                      trigger: "hover"
                    }, {
                      trigger: _withCtx(() => [
                        _createVNode(_component_n_icon, {
                          size: "45",
                          style: {"float":"right","margin-top":"-2px"},
                          color: "#18a058"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_wifi_120_regular)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_n_tooltip, {
                      key: 1,
                      trigger: "hover"
                    }, {
                      trigger: _withCtx(() => [
                        _createVNode(_component_n_icon, {
                          size: "45",
                          style: {"float":"right","margin-top":"-2px"},
                          color: "#d03050"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_wifi_off_20_regular)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_n_layout, {
          style: {"height":"100%"},
          id: "mainContent",
          "has-sider": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_layout_sider, {
              bordered: "",
              "show-trigger": "",
              "collapse-mode": "width",
              "collapsed-width": 64,
              width: 240,
              "native-scrollbar": false,
              style: {"max-height":"320px"},
              collapsed: _ctx.collapsed,
              "onUpdate:collapsed": _ctx.onCollapsed
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_menu, {
                  "onUpdate:value": [
                    _ctx.navigate,
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPageId) = $event))
                  ],
                  mode: "vertical",
                  options: _ctx.navMenuOptions,
                  value: _ctx.currentPageId,
                  "collapsed-width": 64,
                  "collapsed-icon-size": 22
                }, null, 8, ["onUpdate:value", "options", "value"])
              ]),
              _: 1
            }, 8, ["collapsed", "onUpdate:collapsed"]),
            _createVNode(_component_n_layout, {
              style: _normalizeStyle(_ctx.insetStyle)
            }, {
              default: _withCtx(() => [
                (_ctx.initialised)
                  ? (_openBlock(), _createBlock(_component_n_card, {
                      key: 0,
                      title: _ctx.currentPageTitle
                    }, {
                      default: _withCtx(() => [
                        (_ctx.currentPageId =='team/estimate')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              (_ctx.mateCount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createVNode(_component_n_list, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estimatingUsers, (u) => {
                                          return (_openBlock(), _createBlock(_component_n_list_item, { key: u }, {
                                            prefix: _withCtx(() => [
                                              _createVNode(_component_n_button, {
                                                class: "jcard",
                                                disabled: u.id != _ctx.myID,
                                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('~/estimate'))),
                                                type: _ctx.getType(u.estimate)
                                              }, {
                                                default: _withCtx(() => [
                                                  (u.id == _ctx.myID || _ctx.estimateDone)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(u.estimate), 1))
                                                    : _createCommentVNode("", true),
                                                  (u.estimate && u.id != _ctx.myID && !_ctx.estimateDone)
                                                    ? (_openBlock(), _createBlock(_component_n_icon, { key: 1 }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_checkmark_12_filled)
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1032, ["disabled", "type"])
                                            ]),
                                            suffix: _withCtx(() => [
                                              _createVNode(_component_n_avatar, {
                                                round: "",
                                                size: "medium",
                                                src: u.icon
                                              }, null, 8, ["src"])
                                            ]),
                                            default: _withCtx(() => [
                                              (u.id == _ctx.myID)
                                                ? (_openBlock(), _createBlock(_component_n_button, {
                                                    key: 0,
                                                    text: "",
                                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigate('~/estimate'))),
                                                    style: {"font-weight":"bolder"},
                                                    size: "large"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(u.name), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true),
                                              (u.id != _ctx.myID)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(u.name), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128)),
                                        _createVNode(_component_n_list_item, { style: {"margin-top":"24px","padding-bottom":"0px"} }, {
                                          default: _withCtx(() => [
                                            (_ctx.teamReady)
                                              ? (_openBlock(), _createBlock(_component_n_button, {
                                                  key: 0,
                                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.shared.jp.command='start')),
                                                  class: "rightAligned"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_n_icon, { style: {"margin-right":"6px"} }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_play_20_regular)
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _hoisted_7
                                                  ]),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_n_button, {
                                                  key: 1,
                                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.reset())),
                                                  class: "rightAligned",
                                                  disabled: !_ctx.estimateDone
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_n_icon, { style: {"margin-right":"6px"} }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_arrow_reset_20_filled)
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _hoisted_8
                                                  ]),
                                                  _: 1
                                                }, 8, ["disabled"])),
                                            _createVNode(_component_n_button, {
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.reveal())),
                                              class: "rightAligned",
                                              disabled: _ctx.estimateDone || !_ctx.estimateStarted
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_n_icon, { style: {"margin-right":"6px"} }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_checkmark_12_filled)
                                                  ]),
                                                  _: 1
                                                }),
                                                _hoisted_9
                                              ]),
                                              _: 1
                                            }, 8, ["disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _hoisted_11,
                                    _hoisted_12,
                                    _hoisted_13,
                                    _createVNode(_component_n_button, {
                                      type: "primary",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigate('qr')))
                                    }, {
                                      icon: _withCtx(() => [
                                        _createVNode(_component_n_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_qr_code_20_filled)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _hoisted_14
                                      ]),
                                      _: 1
                                    })
                                  ]))
                            ]))
                          : (_ctx.currentPageId =='~/estimate')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                (_ctx.myself.estimating)
                                  ? (_openBlock(), _createBlock(_component_n_grid, {
                                      key: 0,
                                      cols: "1",
                                      "y-gap": "24"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (value) => {
                                          return (_openBlock(), _createBlock(_component_n_grid_item, { key: value }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_n_button, {
                                                class: "jcard",
                                                onClick: ($event: any) => {_ctx.myself.estimate=value; _ctx.navigate('team/estimate');},
                                                strong: "true"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(value), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _hoisted_17,
                                      _hoisted_18,
                                      _hoisted_19,
                                      _createVNode(_component_n_switch, {
                                        value: _ctx.myself.estimating,
                                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.myself.estimating) = $event))
                                      }, {
                                        checked: _withCtx(() => [
                                          _hoisted_20
                                        ]),
                                        unchecked: _withCtx(() => [
                                          _hoisted_21
                                        ]),
                                        _: 1
                                      }, 8, ["value"])
                                    ]))
                              ]))
                            : (_ctx.currentPageId =='team/settings')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createVNode(_component_n_form, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_n_form_item, { label: "Name" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_n_input, {
                                            onKeypress: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.autoNavigate()), ["enter"])),
                                            value: _ctx.shared.jp.title,
                                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.shared.jp.title) = $event)),
                                            type: "text",
                                            placeholder: "Joker Poker"
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_n_form_item, { label: "Mates" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_n_list, {
                                            bordered: "",
                                            style: {"width":"100%"}
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.namedUsers, (u) => {
                                                return (_openBlock(), _createBlock(_component_n_list_item, { key: u }, {
                                                  prefix: _withCtx(() => [
                                                    _createVNode(_component_n_avatar, {
                                                      round: "",
                                                      size: "medium",
                                                      src: u.icon
                                                    }, null, 8, ["src"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_n_grid, {
                                                      cols: "1 s:4",
                                                      responsive: "screen"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_n_grid_item, null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("span", {
                                                              style: _normalizeStyle(u.id == _ctx.myself.id? 'min-width: 88px; display: inline-block; font-weight:bolder;' : 'min-width: 88px; display: inline-block;')
                                                            }, _toDisplayString(u.name), 5)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_n_grid_item, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_n_switch, {
                                                              value: u.estimating,
                                                              "onUpdate:value": ($event: any) => ((u.estimating) = $event)
                                                            }, {
                                                              checked: _withCtx(() => [
                                                                _hoisted_23
                                                              ]),
                                                              unchecked: _withCtx(() => [
                                                                _hoisted_24
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["value", "onUpdate:value"])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_n_grid_item, null, {
                                                          default: _withCtx(() => [
                                                            (u.online)
                                                              ? (_openBlock(), _createBlock(_component_n_tooltip, {
                                                                  key: 0,
                                                                  trigger: "hover"
                                                                }, {
                                                                  trigger: _withCtx(() => [
                                                                    _createVNode(_component_n_icon, {
                                                                      size: "24",
                                                                      color: "#18a058"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_wifi_120_regular)
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    _hoisted_25
                                                                  ]),
                                                                  _: 1
                                                                }))
                                                              : (_openBlock(), _createBlock(_component_n_tooltip, {
                                                                  key: 1,
                                                                  trigger: "hover"
                                                                }, {
                                                                  trigger: _withCtx(() => [
                                                                    _createVNode(_component_n_icon, {
                                                                      size: "24",
                                                                      color: "#d03050"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_wifi_off_20_regular)
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    _hoisted_26
                                                                  ]),
                                                                  _: 1
                                                                }))
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_n_grid_item, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_n_tooltip, {
                                                              trigger: "hover",
                                                              disabled: u.online || u.name != _ctx.myself.name
                                                            }, {
                                                              trigger: _withCtx(() => [
                                                                _createVNode(_component_n_button, {
                                                                  circle: "",
                                                                  type: (u.online || u.name != _ctx.myself.name) ? '':'error',
                                                                  disabled: u.online || u.name != _ctx.myself.name,
                                                                  onClick: ($event: any) => (_ctx.deleteMate(u.id))
                                                                }, {
                                                                  icon: _withCtx(() => [
                                                                    _createVNode(_component_n_icon, null, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_delete_16_regular)
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["type", "disabled", "onClick"])
                                                              ]),
                                                              default: _withCtx(() => [
                                                                _hoisted_27
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["disabled"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              }), 128))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_n_form_item, { label: "Values" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_n_input, {
                                            value: _ctx.shared.jp.values,
                                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.shared.jp.values) = $event)),
                                            type: "textarea",
                                            rows: _ctx.values.length,
                                            placeholder: "one value per line, lowest weigt first, ? has no weight"
                                          }, null, 8, ["value", "rows"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_n_button, {
                                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.shared.jp.values = _ctx.defaultValues)),
                                        class: "rightAligned",
                                        disabled: _ctx.shared.jp.values == _ctx.defaultValues
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_n_icon, { style: {"margin-right":"6px"} }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_arrow_reset_20_filled)
                                            ]),
                                            _: 1
                                          }),
                                          _hoisted_28
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_ctx.currentPageId =='~/settings')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _createVNode(_component_n_form, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_n_form_item, { label: "Name" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_n_input, {
                                              onKeypress: _cache[13] || (_cache[13] = _withKeys(($event: any) => (_ctx.autoNavigate()), ["enter"])),
                                              value: _ctx.myself.name,
                                              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.myself.name) = $event)),
                                              type: "text",
                                              placeholder: _ctx.myself.estimating? 'Please enter your name' : '',
                                              autofocus: true
                                            }, null, 8, ["value", "placeholder"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_n_form_item, { label: "Email" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_n_input, {
                                              onKeypress: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.autoNavigate()), ["enter"])),
                                              value: _ctx.myself.email,
                                              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.myself.email) = $event)),
                                              type: "text",
                                              placeholder: ""
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_n_switch, {
                                          value: _ctx.myself.estimating,
                                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.myself.estimating) = $event))
                                        }, {
                                          checked: _withCtx(() => [
                                            _hoisted_30
                                          ]),
                                          unchecked: _withCtx(() => [
                                            _hoisted_31
                                          ]),
                                          _: 1
                                        }, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_ctx.currentPageId =='qr')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      _createVNode(_component_n_image, {
                                        "object-fit": "contain",
                                        src: 'https://api.qrserver.com/v1/create-qr-code/?size='+(_ctx.isSmallScreen?'300x300':'600x600')+'&data='+_ctx.sessionURL
                                      }, null, 8, ["src"]),
                                      _hoisted_33,
                                      _hoisted_34,
                                      _createTextVNode(" You have " + _toDisplayString(_ctx.mateCount) + " mate(s). ", 1),
                                      _hoisted_35,
                                      _withDirectives(_createElementVNode("span", null, "The team is ready.", 512), [
                                        [_vShow, _ctx.teamReady]
                                      ]),
                                      _hoisted_36,
                                      _createVNode(_component_n_a, { href: _ctx.sessionURL }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.sessionURL), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["href"]),
                                      _createVNode(_component_n_tooltip, {
                                        trigger: "hover",
                                        placement: "top"
                                      }, {
                                        trigger: _withCtx(() => [
                                          _createVNode(_component_n_button, {
                                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.copyToClipBoard(_ctx.sessionURL))),
                                            style: {"margin-left":"12px"}
                                          }, {
                                            icon: _withCtx(() => [
                                              (_ctx.clipIcon=='copy')
                                                ? (_openBlock(), _createBlock(_component_n_icon, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_copy_16_regular)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_n_icon, { key: 1 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_checkmark_12_filled)
                                                    ]),
                                                    _: 1
                                                  }))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          _hoisted_37
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["title"]))
                  : (_openBlock(), _createBlock(_component_n_card, { key: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_38,
                        _hoisted_39,
                        _hoisted_40,
                        _createVNode(_component_n_spin, { size: "large" })
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }),
        _createVNode(_component_n_layout_footer, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_progress, {
              type: "line",
              percentage: _ctx.estimateProgress,
              "show-indicator": false,
              status: "success",
              height: 1,
              "border-radius": 0
            }, null, 8, ["percentage"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_41
  ], 64))
}